<template>
  <div class="div_all">
    <div class="div_search">
      <div class="div_owner">
<!--        <el-radio v-model="searchForm.ownernum" label="新车">新车</el-radio>-->
<!--        <el-radio v-model="searchForm.ownernum" label="二手">二手</el-radio>-->
<!--        <el-radio v-model="searchForm.ownernum" label="其他">其他</el-radio>-->
        <el-radio-group v-model="searchForm.ownernum">
          <el-radio-button label="一手自用"></el-radio-button>
          <el-radio-button label="二手过户"></el-radio-button>
          <el-radio-button label="多次转手"></el-radio-button>
        </el-radio-group>
      </div>
      <div class="div_brand">
        <el-select v-model="searchForm.brand" clearable placeholder="汽车品牌">
          <el-option
              v-for="item in brandList"
              :key="item.id"
              :label="item.brandinfo"
              :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="div_brand">
        <el-select v-model="searchForm.category" clearable placeholder="汽车类型">
          <el-option
              v-for="item in categoryList"
              :key="item"
              :label="item"
              :value="item">
          </el-option>
        </el-select>
      </div>
      <div class="div_brand">
        <el-select v-model="searchForm.price" clearable placeholder="价格区间">
          <el-option
              v-for="item in priceList"
              :key="item.show"
              :label="item.show"
              :value="item.price">
          </el-option>
        </el-select>
      </div>
      <div class="div_brand">
        <el-button type="info" @click="reset">重置</el-button>
        <el-button type="warning" @click="searchCar">找车</el-button>
      </div>

    </div>
    <div class="div_showCar">
      <div class="card" v-for="(car,index) in carList" :key="index" @click="openModule(index,car)">
        <img :src="car.imgone" style='width: 200px'/>
        <p class="card-text">{{car.fullname}}</p>
      </div>
    </div>

<!--    <el-row :gutter="20" style="margin-bottom: 20px">-->
<!--      <el-col :span="4" v-for="(car,index) in carList" :key="index">-->
<!--        <div  style="margin-bottom: 20px;cursor: pointer;line-height: 18px" @click="openModule(index,car)">-->
<!--          <el-avatar shape="square" :size="100" :fit="'contain'" :src="car.imgone"></el-avatar>-->
<!--          <br>-->
<!--          <span class="title" >{{ car.fullname }}</span>-->
<!--        </div>-->
<!--      </el-col>-->
<!--    </el-row>-->


    <el-dialog title="车辆信息" :visible.sync="dialogFormVisible">
      <el-form :model="car">
        <el-form-item label="汽车名称:" :label-width="formLabelWidth" class="item_show">
          <span style="font-size: large;color: orangered">{{car.fullname}}</span>
        </el-form-item>
        <el-form-item label="汽车品牌:" :label-width="formLabelWidth" class="item_show">
          <span>{{car.brandinfo}}</span>
        </el-form-item>
        <el-form-item label="汽车类型:" :label-width="formLabelWidth" class="item_show">
          <span>{{car.category}}</span>
        </el-form-item>
        <el-form-item label="颜色:" :label-width="formLabelWidth" class="item_show">
          <span>{{car.color}}</span>
        </el-form-item>
        <el-form-item label="期望售价:" :label-width="formLabelWidth" class="item_show">
          <span>{{car.price/1000000}}万元</span>
        </el-form-item>
        <el-form-item label="车辆照片1:" :label-width="formLabelWidth" class="item_show" v-if="car.imgone">
          <img :src="car.imgone" alt="">
        </el-form-item>
        <el-form-item label-width="40%">
            <el-button type="success" @click="func(car.id)">查看详情</el-button>
        </el-form-item>

      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "BuyCar",
  data(){
    return{
      dialogFormVisible:false,
      car:{},
      carList:[],
      formLabelWidth: '120px',
      brandList:[],
      categoryList:['轿车','跑车','SUV','越野'],
      priceList:[
        {
          show:'1万以下',
          price:1 * 1000000
        },
        {
          show:'3万以下',
          price:3 * 1000000
        },
        {
          show:'5万以下',
          price:5 * 1000000
        },
        {
          show:'10万以下',
          price:10 * 1000000
        },
        {
          show:'20万以下',
          price:20 * 1000000
        },
        {
          show:'不限',
          price:100 * 1000000
        },
      ],
      searchForm:{
        ownernum: '',
        brand: '',
        category:'',
        price:''

      }
    }
  },
  methods:{
    openModule(index,car){
      this.dialogFormVisible = true
      this.car = car
    },
    func(carId){
      this.$router.push({path:'/index/carInfo',query:{carId:carId}});
    },
    reset(){
      this.searchForm.ownernum = ''
      this.searchForm.brand = ''
      this.searchForm.category = ''
      this.searchForm.price = ''
    },
    searchCar(){
      var fd = new FormData()
      fd.append('info',JSON.stringify(this.searchForm))
      this.axios.post('/search/searchCar',fd).then(res => {
        if(res.data.code === 0){
          this.carList = res.data.data.carList
        }
      })
    },
    getAllCar(){
      this.axios.get('/car/getAllCarList').then(res => {
        if(res.data.code === 0){
          this.carList = res.data.data.carList
        }else {
          this.$message.warning('啊哦，暂无合适的车呢')
        }
      })
    },
    getAllBrandList(){
      this.axios.get('/car/getCarBrandList').then(res =>{
        if(res.data.code === 0){
          this.brandList = res.data.data.brandList
        }
      })
    }
  },
  created() {
    this.getAllCar()
    this.getAllBrandList()
  }
}
</script>

<style scoped>
.div_all {
  height: 100%;
}

.div_search {
  height: 15%;
  background-color: rgba(216,210,194,0.51);
  /*text-align: center;*/
}
.div_owner{
  display: inline-block;
  padding-top: 2%;
  padding-left: 4%;
  /*font-size: xxx-large;*/
}
.div_brand{
  display: inline-block;
  padding-top: 2%;
  padding-left: 4%;
}
.div_showCar {
  display: flex;
  flex-wrap: wrap;
}
.card {
  float: left;
  width: 15%;
  padding: .75rem;
  margin-bottom: 2rem;
  border: 1px solid #efefef;
  text-align: center;
  cursor: pointer;
}
.card-text {
  font-size: 85%;
}
.item_show {
  display: inline-block;
}
.item_show >>> img {
  width: 100px;
  height: 100px;
}
</style>